import { apiGet, apiPatch, apiPost } from './apiClient.js';

export const notificationsApi = {
  /** @returns {Promise<{items: object[], meta: {unreadCount: number, total: number, limit: number}}>} */
  list:     ()   => apiGet('/api/notifications', { limit: 20 }),
  markRead: (id) => apiPatch(`/api/notifications/${id}/read`),
  readAll:  ()   => apiPost('/api/notifications/read-all'),
};
